import { render, staticRenderFns } from "./PhoneForm.vue?vue&type=template&id=dec93af6&"
import script from "./PhoneForm.vue?vue&type=script&lang=js&"
export * from "./PhoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports